import React from 'react'
import { useSelector } from 'react-redux'

import { getFlowTag } from '../../../redux/slices/userSlice'
import { filtersList, zombifyList } from '../../../utils/data'

import './styles.scss'

const Filters = ({ filter, setFilter }) => {
	const flow_tag = useSelector(getFlowTag)

	const handleSelectFilter = filterType => setFilter(filterType)

	return (
		<div className="filters">
			<h1 className="filters__answer">Choose a preferable style</h1>
			<div className="filters-list">
				{flow_tag === '55'
					? zombifyList.map(filterType => (
							<div
								key={filterType.videoSrc}
								className={`video-wrrapper ${
									filter === filterType.name ? 'video-wrrapper--active' : ''
								}`}
								onClick={() => handleSelectFilter(filterType.name)}
							>
								<video
									autoPlay="autoplay"
									loop
									muted
									src={filterType.videoSrc}
									type="video/mp4"
									className="video"
									playsInline
								/>
							</div>
					  ))
					: filtersList.map(filterType => (
							<div
								key={filterType.videoSrc}
								className={`video-wrrapper ${
									filter === filterType.name ? 'video-wrrapper--active' : ''
								}`}
								onClick={() => handleSelectFilter(filterType.name)}
							>
								<video
									autoPlay="autoplay"
									loop
									muted
									src={filterType.videoSrc}
									type="video/mp4"
									className="video"
									playsInline
								/>
							</div>
					  ))}
			</div>
		</div>
	)
}

export { Filters }
